/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandPrintables = createReactComponent("outline", "brand-printables", "IconBrandPrintables", [["path", { "d": "M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5z", "key": "svg-0" }]]);

export { IconBrandPrintables as default };
//# sourceMappingURL=IconBrandPrintables.mjs.map
